declare var CKEDITOR: any;
declare var ko: any;

export function disableAllEditors() {

    for (const instance in CKEDITOR.instances) {
        const editor = CKEDITOR.instances[instance]
        editor.setReadOnly(true);
        editor.editable().attachListener(editor.editable(), 'click', function (evt) {
            evt.stop();
            evt.data.preventDefault();
        }, null, null, 0);
    }
}

export function generate_random(len = 5, arr = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789') {
    let ans = '';
    for (let i = len; i > 0; i--) {
        ans += arr[(Math.floor(Math.random() * arr.length))];
    }
    return ans;
}

export function makePermalinkFromTitle(title) {

    let permalink = title.toLowerCase().trim()
            .replace(/[^\w -]+/g, '')
            .replace(/[ _]+/g, '-')
            .replace(/-{2,}/g, '-')
            .replace(/-$/g, "")
            .replace(/^-/g, "");

    return permalink;
}


export function slugify(text) {
    text = text.toString().toLowerCase().trim();

    const sets = [
        {to: 'a', from: '[ÀÁÂÃÄÅĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]'},
        {to: 'ae', from: '[æÆ]'},
        {to: 'c', from: '[ÇĆĈČ]'},
        {to: 'd', from: '[ÐĎĐÞ]'},
        {to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
        {to: 'f', from: '[ƒ]'},
        {to: 'g', from: '[ĜĞĢǴ]'},
        {to: 'h', from: '[ĤḦ]'},
        {to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
        {to: 'j', from: '[Ĵ]'},
        {to: 'ij', from: '[Ĳ]'},
        {to: 'k', from: '[Ķ]'},
        {to: 'l', from: '[ĹĻĽŁ]'},
        {to: 'm', from: '[Ḿ]'},
        {to: 'n', from: '[ÑŃŅŇ]'},
        {to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
        {to: 'oe', from: '[Œ]'},
        {to: 'p', from: '[ṕ]'},
        {to: 'r', from: '[ŔŖŘ]'},
        {to: 's', from: '[ßŚŜŞŠȘ]'},
        {to: 't', from: '[ŢŤ]'},
        {to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
        {to: 'w', from: '[ẂŴẀẄ]'},
        {to: 'x', from: '[ẍ]'},
        {to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
        {to: 'z', from: '[ŹŻŽ]'},
        {to: '-', from: '[·/_,:;\']'},
        {to: '-', from: '/d\\+1/'}
    ];

    sets.forEach(set => {
        text = text.replace(new RegExp(set.from,'gi'), set.to)
    });

    return text
        .replace(/\s+/g, '-')    // Replace spaces with -
        .replace(/[^-a-zа-я\u0370-\u03ff\u1f00-\u1fff]+/g, '-') // Remove all non-word chars
        .replace(/--+/g, '-')    // Replace multiple - with single -
        .replace(/^-+/, '')      // Trim - from start of text
        .replace(/-+$/, '')      // Trim - from end of text
}


export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}


export function JStoKO(o : Object, isNested = true){
    let koModel = {}
    for (const k in o) {
        switch (typeof o[k]) {
            case "boolean":
            case "number":
            case "string":
            //@ts-ignore
            case "bigint":
            case "undefined":
                koModel[k] = ko.observable(o[k])
                break;
            case "function":
                break;
            case "symbol":
                break;
            case "object":
                if(Array.isArray(o[k])) koModel[k] = ko.observableArray(o[k])
                else if(isNested) koModel[k] = JStoKO(o[k], isNested)
                break;
        }
    }
    return koModel
}

export function JSONtoKO(json : string, isNested = true ) {
    try {
        let js = JSON.parse(json)
        return JStoKO(js, isNested)
    }catch (e) {
        return ""
    }
}


export function chunkObservableArray(observableArray : any[] , chunkSize: number ){
    if(chunkSize == 0) return [ko.observableArray(observableArray)] //No chunk!
    let chunkArray = []
    for (let i = 0; i < observableArray.length; i += chunkSize) {
        const chunk = observableArray.slice(i, i + chunkSize);
        chunkArray.push(ko.observableArray(chunk))
    }
    return chunkArray
}

export const sleep = async (milliseconds) => {
    await new Promise(resolve => {
        return setTimeout(resolve, milliseconds)
    });
}






// WEBPACK FOOTER //
// ./js/utils/Helpers.ts